import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  Flex,
  Text,
  Link,
  VStack,
} from "@chakra-ui/react";
import MainLayout from "components/mainLayout";
import Topbar from "components/topbar";
import { useState } from "react";

const tabLabels = [
  "How it works",
  "Items we Accept",
  "Tracking Items",
  "Pricing",
  "Payment Calculations",
  "Hidden Costs",
];

const howItWorksSteps = [
  "Register your details",
  "Request a bag and schedule a pick up, ship to us or drop off",
  "Keep track of your items",
  "Our team of experts will do all the work to sell your items",
  "Get paid by cash or credit",
];

const FAQS = () => {
  const [value, setValue] = useState(0);

  return (
    <MainLayout>
      <Box height="100%">
        <Topbar title="FAQs" />
        <Flex
          bg="#f8fbff"
          padding={6}
          direction="column"
          gap={4}
          height={"100vh"}
        >
          <Tabs
            padding={4}
            bg={"#fff"}
            index={value}
            onChange={setValue}
            variant="unstyled"
            isLazy
          >
            <TabList borderBottom="none" gap={6}>
              {tabLabels.map((label, index) => (
                <Tab
                  key={index}
                  _selected={{
                    color: "#000000",
                    fontWeight: "600",
                    borderBottom: "2px solid #000000",
                    fontsize: "16px",
                  }}
                  color="#A0A0A0"
                  border="none"
                  borderBottom="2px solid transparent"
                  _focus={{ boxShadow: "none" }}
                  paddingBottom="8px"
                >
                  {label}
                </Tab>
              ))}
            </TabList>

            <TabPanels height={"100vh"}>
              <TabPanel paddingX={0}>
                <Flex
                  bg="white"
                  p={4}
                  direction="column"
                  gap={4}
                  borderRadius="xl"
                >
                  {howItWorksSteps.map((step, index) => (
                    <Box
                      key={index}
                      border="1px solid #E2E8F0"
                      borderRadius="lg"
                      p={4}
                      bg="white"
                    >
                      <Text
                        fontSize={"20px"}
                        fontWeight={"400"}
                        fontFamily={"PlusJakartaSansRegular"}
                      >
                        {step}
                      </Text>
                    </Box>
                  ))}
                </Flex>
              </TabPanel>

              <TabPanel paddingX={0}>
                <Flex
                  bg="white"
                  p={4}
                  direction="column"
                  gap={4}
                  borderRadius="xl"
                >
                  <Text
                    fontSize={"20px"}
                    fontWeight={"500"}
                    color={"#000000"}
                    fontFamily={"PlusJakartaSansMedium"}
                  >
                    Q: What type of items do you accept?
                  </Text>
                  {[
                    "We accept all genders from new born to 14 years",
                    "We accept all garment, outerwear, accessories and unworn footwear",
                    "We accept only designer brands, not high street (link to search brands)",
                    "We accept items where the original RRP is above £45",
                    "We accept items that are new with or without tags or barely worn items (no stains, tears or wear)",
                  ].map((item, index) => (
                    <Box
                      key={index}
                      border="1px solid #E2E8F0"
                      borderRadius="lg"
                      p={4}
                      bg="white"
                    >
                      {item.includes("(link to search brands)") ? (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          We accept only designer brands, not high street{" "}
                          <Link href="#" textDecoration="none">
                            (link to search brands)
                          </Link>
                        </Text>
                      ) : (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          {item}
                        </Text>
                      )}
                    </Box>
                  ))}
                </Flex>
              </TabPanel>
              <TabPanel paddingX={0}>
                <Flex
                  bg="white"
                  p={4}
                  direction="column"
                  gap={4}
                  borderRadius="xl"
                >
                  <Text
                    fontSize={"20px"}
                    fontWeight={"500"}
                    color={"#000000"}
                    fontFamily={"PlusJakartaSansMedium"}
                  >
                    Q: How do I track my items?
                  </Text>
                  {[
                    "We send you processed items for approval before they are listed ",
                    "Rejected items are donated to our charity partners ",
                    "Returned items inccur a cost of £2.95 per item",
                    "Items status can be tracked online",
                    "We sell items online and across our department stores and pop-ups",
                  ].map((item, index) => (
                    <Box
                      key={index}
                      border="1px solid #E2E8F0"
                      borderRadius="lg"
                      p={4}
                      bg="white"
                    >
                      {item.includes("(link to search brands)") ? (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          We accept only designer brands, not high street{" "}
                          <Link href="#" textDecoration="none">
                            (link to search brands)
                          </Link>
                        </Text>
                      ) : (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          {item}
                        </Text>
                      )}
                    </Box>
                  ))}
                </Flex>
              </TabPanel>
              <TabPanel paddingX={0}>
                <Flex
                  bg="white"
                  p={4}
                  direction="column"
                  gap={4}
                  borderRadius="xl"
                >
                  <Text
                    fontSize={"20px"}
                    fontWeight={"500"}
                    color={"#000000"}
                    fontFamily={"PlusJakartaSansMedium"}
                  >
                    Q: How do you value and price items?
                  </Text>
                  {[
                    "We calculuate resale prices based on brand and condition of the item (typical resale prices are 60% of the orirginal RRP) ",
                    "We dynamically reduce resale prices to help them sell quuickly (typically by an additional 10% every 3 months)",
                  ].map((item, index) => (
                    <Box
                      key={index}
                      border="1px solid #E2E8F0"
                      borderRadius="lg"
                      p={4}
                      bg="white"
                    >
                      {item.includes("(link to search brands)") ? (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          We accept only designer brands, not high street{" "}
                          <Link href="#" textDecoration="none">
                            (link to search brands)
                          </Link>
                        </Text>
                      ) : (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          {" "}
                          {item}
                        </Text>
                      )}
                    </Box>
                  ))}
                </Flex>
              </TabPanel>
              <TabPanel paddingX={0}>
                <Flex
                  bg="white"
                  p={4}
                  direction="column"
                  gap={4}
                  borderRadius="xl"
                >
                  <Text
                    fontSize={"20px"}
                    fontWeight={"500"}
                    color={"#000000"}
                    fontFamily={"PlusJakartaSansMedium"}
                  >
                    Q: How are payments calcuated and made?
                  </Text>
                  {[
                    "We pay 50% commssion of the price sold",
                    "Payments are made at the end of each month follwing a 30 days return period we offer customers.",
                  ].map((item, index) => (
                    <Box
                      key={index}
                      border="1px solid #E2E8F0"
                      borderRadius="lg"
                      p={4}
                      bg="white"
                    >
                      {item.includes("(link to search brands)") ? (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          We accept only designer brands, not high street{" "}
                          <Link href="#" textDecoration="none">
                            (link to search brands)
                          </Link>
                        </Text>
                      ) : (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          {item}
                        </Text>
                      )}
                    </Box>
                  ))}
                </Flex>
              </TabPanel>
              <TabPanel paddingX={0}>
                <Flex
                  bg="white"
                  p={4}
                  direction="column"
                  gap={4}
                  borderRadius="xl"
                >
                  <Text
                    fontSize={"20px"}
                    fontWeight={"500"}
                    color={"#000000"}
                    fontFamily={"PlusJakartaSansMedium"}
                  >
                    Q: Are there any additional charges?
                  </Text>
                  {[
                    "We charge cleaning cost where necessary £3.95 for garment and £5.50 for outerwear",
                    "Returned items inccurr a charge of £2.95 per items",
                  ].map((item, index) => (
                    <Box
                      key={index}
                      border="1px solid #E2E8F0"
                      borderRadius="lg"
                      p={4}
                      bg="white"
                    >
                      {item.includes("(link to search brands)") ? (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          We accept only designer brands, not high street{" "}
                          <Link href="#" textDecoration="none">
                            (link to search brands)
                          </Link>
                        </Text>
                      ) : (
                        <Text
                          fontSize={"16px"}
                          fontWeight={"400"}
                          color={"#898989"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          {item}
                        </Text>
                      )}
                    </Box>
                  ))}
                </Flex>
              </TabPanel>

              {/* Render empty panels for remaining tabs */}
              {tabLabels.slice(2).map((label, index) => (
                <TabPanel key={index + 2}>
                  <Text>{label} content coming soon...</Text>
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </Flex>
      </Box>
    </MainLayout>
  );
};

export default FAQS;
